export default __webpack_public_path__ + "static/media/Devastating Thrash.87d0c719.png";